import {
  mdiChevronLeft,
  mdiCommentOutline,
  mdiContentCopy,
  mdiFileDocument,
  mdiHistory,
  mdiReload,
} from "@mdi/js";
import Icon from "@mdi/react";
import { FunctionComponent, useEffect, useRef, useState } from "react";
import { NavLink, Route, useHistory, useRouteMatch } from "react-router-dom";
import {
  ModalAlignment,
  ModalType,
  useModal,
} from "../../../../context_providers/modal/modal_context";
import OrderDetailContext, {
  useOrderDetailCtx,
} from "../../../../context_providers/order_detail_context";
import {
  ToastType,
  useToast,
} from "../../../../context_providers/toast/toast_ctx";
import { ACTION, MODULE, OrderStatus } from "../../../../utils/enums";
import ActionHistory from "../order_list/components/history_logs";
import "../components/orders_mobile.css";
import StatusBadge from "../../../new_components/common/status/status_badge";
import OrderComments from "../order_list/components/order_comments";
import BillingProfileWidget from "./billing_profile/billing_profile_widget";
import ExtraSectionWidget from "./extra_section/extra_section_widget";
import OrderAttachmentWidget from "./order_attachement_widget";
import OrderDetailSection from "./order_detail_section";
import OrderDeviceSection from "./order_devices/order_devices_section";
import ProductSection from "./product/product_section";
import DeliveryProfileWidget from "./billing_profile/delivery_profile_widget";
import WorkCompletionReportSection from "../components/work_completion_report";
import BoqReportSection from "../components/boq_report";
import BottomSheetViewWidget from "../order_create/bottom_sheet_view";
import CustomerInformation from "./billing_profile/cutomer_information_widget";
import { useAuth } from "../../../../context_providers/auth/authProvider";
import CurrencyInfoSection from "./CurrencyInfoWidget";
import SubscriptionSection from "./subscription/subscription_section";

interface OrderDetailPageProps {
  location: any;
}

const OrderDetailPage: FunctionComponent<OrderDetailPageProps> = (props) => {
  return (
    <>
      <OrderDetailContext>
        <OrderDetail />
      </OrderDetailContext>
    </>
  );
};

export default OrderDetailPage;

interface OrderDetailProps {}

const OrderDetail: FunctionComponent<OrderDetailProps> = () => {
  const { showToast } = useToast();
  const { showModal } = useModal();
  const { getOrder, order, onOrderDetailUpdated } = useOrderDetailCtx();
  const history = useHistory();
  const ref = useRef(null);
  const { isAuthorised } = useAuth();
  const { url, path } = useRouteMatch();

  const [isWarehouseOperator, setIsWarehouseOperator] = useState(false);

  useEffect(() => {
    const cb = (e: KeyboardEvent) => {
      if (!e.key) return;
      if (e.key === "Escape") {
        history.goBack();
      } else if (e.key.toLowerCase() === "z" && e.altKey) {
        history.push(`${url}`);
      } else if (e.key.toLowerCase() === "x" && e.altKey) {
        history.push(`${url}/subscription`);
      } else if (e.key.toLowerCase() === "c" && e.altKey) {
        history.push(`${url}/payments`);
      } else if (e.key.toLowerCase() === "v" && e.altKey) {
        history.push(`${url}/devices`);
      } else if (e.key.toLowerCase() === "b" && e.altKey) {
        showComment();
      } else if (e.key.toLowerCase() === "n" && e.altKey) {
        showLog();
      }
    };
    document.addEventListener("keyup", cb);
    return () => document.removeEventListener("keyup", cb);
  }, []);

  const showComment = () => {
    showModal({
      title: "Comment and Remarks",
      type: ModalType.drawer,
      alignment: ModalAlignment.right,
      container: (id) => (
        <OrderComments
          onRemarkChange={(d) => onOrderDetailUpdated(d as any)}
          order={{
            order_id: order.order_id,
            hold_remark: order.hold_remark,
            registration_remark: order.registration_remark,
            remark: order.remark,
            subsidy_status: order.subsidy_status,
          }}
        />
      ),
    });
  };

  const showLog = () => {
    showModal({
      title: "Logs",
      type: ModalType.drawer,
      alignment: ModalAlignment.right,
      container: (id) => <ActionHistory order_id={order.order_id as any} />,
    });
  };

  const showWorkCompletionReport = () => {
    showModal({
      title: "Work completion report",
      type: ModalType.drawer,
      alignment: ModalAlignment.right,
      container: (id) => (
        <WorkCompletionReportSection order_id={order.order_id as any} />
      ),
    });
  };

  const showBoqReport = () => {
    showModal({
      title: "Boq report",
      type: ModalType.drawer,
      alignment: ModalAlignment.right,
      container: (id) => <BoqReportSection order_id={order.order_id as any} />,
    });
  };

  useEffect(() => {
    const warehouse_operator_permissions = isAuthorised({
      module: MODULE.warehouse_operator,
      action: [ACTION.READ],
    });

    setIsWarehouseOperator(warehouse_operator_permissions);
  }, [isAuthorised]);
  return (
    <>
      {!isWarehouseOperator && (
        <div
          ref={ref}
          className="fixed bottom-24 right-3 md:bottom-3 flex flex-col justify-center items-center gap-2 z-10"
        >
          <button
            title="Work completion reports"
            onClick={showWorkCompletionReport}
            className="  rounded-full p-1.5 hover:scale-105 transform duration-150 bg-myPrimaryColor text-white   shadow cursor-pointer flex items-center justify-center"
          >
            <Icon path={mdiFileDocument} className="h-6 w-6  "></Icon>
          </button>
          <button
            title="Boq reports"
            onClick={showBoqReport}
            className="  rounded-full p-1.5 hover:scale-105 transform duration-150 bg-myPrimaryColor text-white   shadow cursor-pointer flex items-center justify-center"
          >
            <Icon path={mdiFileDocument} className="h-6 w-6  "></Icon>
          </button>
          <button
            title="Comment and Remarks"
            onClick={showComment}
            className="  rounded-full p-1.5 hover:scale-105 transform duration-150 bg-myPrimaryColor text-white   shadow cursor-pointer flex items-center justify-center"
          >
            <Icon path={mdiCommentOutline} className="h-6 w-6  "></Icon>
          </button>

          <button
            title="Logs"
            onClick={showLog}
            className=" rounded-full p-1.5 hover:scale-105 transform duration-150    bg-myPrimaryColor text-white   shadow cursor-pointer flex items-center justify-center"
          >
            <Icon path={mdiHistory} className="h-6 w-6  "></Icon>
          </button>
        </div>
      )}
      <div className="orders-mobile-shrink relative bg-myBgcolor h-screen   overflow-auto">
        <div
          className={`sticky top-0 z-10  bg-gradient-to-b ${
            order.status === OrderStatus.CANCELLED
              ? "from-red-400"
              : order.status === OrderStatus.INIT
                ? "from-yellow-400"
                : "from-green-400"
          } to-myBgcolor`}
        >
          <div className="flex flex-col gap-1 md:flex-row md:justify-between md:items-center select-none text-white">
            <div className="flex items-center gap-2 px-1">
              {!isWarehouseOperator && (
                <button
                  className="flex items-center gap-1 p-1 hover:text-gray-200 shrink-0 font-semibold md:text-lg"
                  onClick={() => {
                    history.goBack();
                  }}
                  title="Back"
                >
                  <Icon path={mdiChevronLeft} className="h-6 w-6" />
                  <span className="hidden md:inline">Back</span>
                </button>
              )}
              <div
                onClick={() => {
                  navigator.clipboard.writeText(order.order_id);
                  showToast({
                    type: ToastType.info,
                    text: "Copied to clipboard !",
                  });
                }}
                className="flex gap-2 items-center cursor-pointer hover:text-gray-200 min-w-0"
              >
                <Icon path={mdiContentCopy} className="w-4 h-4 shrink-0"></Icon>
                <h2 className="text-lg font-semibold shrink-0">ORDER #</h2>
                <h2 className="text-lg font-semibold italic break-all">
                  {order.order_id}
                </h2>
              </div>
            </div>
            <div className="flex items-center gap-2 flex-wrap px-1 pb-1">
              <StatusBadge status={order.status} kind="order" />
              <StatusBadge status={order.payment_status} kind="payment" />
              <button
                className="flex items-center p-1 hover:text-gray-200"
                onClick={() => getOrder()}
                title="Refresh"
              >
                <Icon path={mdiReload} className="h-4 w-4" />
              </button>
            </div>
          </div>
          <div className="flex md:justify-center gap-2 py-2 px-2 text-sm items-center overflow-x-auto whitespace-nowrap">
            {!isWarehouseOperator && (
              <>
                <NavLink
                  exact
                  to={`${url}`}
                  activeClassName="bg-myPrimaryColor text-white"
                  className="rounded-3xl py-1.5 px-4 bg-white shadow cursor-pointer flex items-center justify-center whitespace-nowrap shrink-0"
                >
                  <p className="">Order Details</p>
                </NavLink>
                <NavLink
                  to={`${url}/subscription`}
                  activeClassName="bg-myPrimaryColor text-white"
                  className="rounded-3xl py-1.5 px-4 bg-white shadow cursor-pointer flex items-center justify-center whitespace-nowrap shrink-0"
                >
                  <p className="">Subscription</p>
                </NavLink>
                {/* <NavLink
                  to={`${url}/payments`}
                  activeClassName="bg-myPrimaryColor text-white"
                  className="rounded-3xl py-1.5 px-4 bg-white shadow cursor-pointer flex items-center justify-center whitespace-nowrap shrink-0"
                >
                  <p className="">Payments</p>
                </NavLink> */}
              </>
            )}
            <NavLink
              to={`${url}/devices`}
              activeClassName="bg-myPrimaryColor text-white"
              className="rounded-3xl py-1.5 px-4 bg-white shadow cursor-pointer flex items-center justify-center whitespace-nowrap shrink-0"
            >
              <p className="">Devices</p>
            </NavLink>
            {!isWarehouseOperator && (
              <NavLink
                to={`${url}/attachment`}
                activeClassName="bg-myPrimaryColor text-white"
                className="rounded-3xl py-1.5 px-4 bg-white shadow cursor-pointer flex items-center justify-center whitespace-nowrap shrink-0"
              >
                <p className="text-sm">Attachments</p>
              </NavLink>
            )}
          </div>
        </div>

        <Route exact path={`${path}`}>
          <div
            className="p-2 md:p-5 right-0
              transform duration-500 ease-in-out   slide_drawer_ltr "
          >
            <section>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                {/* Customer Information */}
                <div className="">
                  <h3 className="text-xl font-semibold text-gray-800">
                    Customer Information
                  </h3>
                  <CustomerInformation />
                </div>

                {/* Billing Details */}
                <div className="mt-4 md:mt-0">
                  <h3 className="text-xl font-semibold text-gray-800">
                    Billing Details
                  </h3>
                  <BillingProfileWidget />
                </div>

                {/* Delivery Details */}
                <div className="mt-4 md:mt-0">
                  <h3 className="text-xl font-semibold text-gray-800">
                    Delivery Details
                  </h3>
                  <DeliveryProfileWidget />
                </div>
              </div>
            </section>
            <div className="my-12">
              <CurrencyInfoSection />
              <ProductSection />
            </div>{" "}
            <div className="">
              <OrderDetailSection />
            </div>
            <div className="grid grid-cols-1  gap-5 my-5">
              <div className="">
                <ExtraSectionWidget />
              </div>
            </div>
          </div>
        </Route>
        {/* <Route path={`${path}/payments`}>
          <div
            className="m-5 right-0
            transform duration-500 ease-in-out   slide_drawer_rtl"
          >
            <PaymentSectionWidget />
          </div>
        </Route> */}
        <Route path={`${path}/subscription`}>
          <div className="p-5">
            <SubscriptionSection />
          </div>
        </Route>

        <Route path={`${path}/devices`}>
          <OrderDeviceSection />
        </Route>
        <Route path={`${path}/attachment`}>
          <OrderAttachmentWidget order_id={order.order_id} />
        </Route>

        {(order?.products?.length > 0 ||
          order?.services?.length > 0 ||
          order?.raw_materials?.length > 0 ||
          order?.discountData?.length > 0 ||
          order?.excessData?.length > 0) && (
          <div className="sticky bottom-0 right-0 mt-3 w-full rounded-t-md bg-white shadow-sm py-3 px-5">
            <BottomSheetViewWidget />
          </div>
        )}
      </div>
    </>
  );
};
